export default __webpack_public_path__ + "static/media/7_1_2.c22e59d2.png";